import { IS_MODAL_VISIBLE } from "../actions/types";

/** Modal slice of the store. */
export interface ModalState {
  isModalVisible: boolean;
  modalType: string;
  subType: string;
}

/** Payload fields the modal reducer reads. */
export interface ModalAction {
  type: string;
  isModalVisible?: boolean;
  modalType?: string;
  subType?: string;
}

export const initialModalState: ModalState = {
  isModalVisible: false,
  modalType: "",
  subType: ""
};

/*
 * Responds to modal actions and updates the appropriate state
 */
export function changeModalVisibility(
  state: ModalState | undefined,
  action: ModalAction
): ModalState {
  if (typeof state === "undefined") {
    return initialModalState;
  }
  switch (action.type) {
    case IS_MODAL_VISIBLE:
      return Object.assign({}, state, {
        isModalVisible: action.isModalVisible ?? false,
        modalType: action.modalType ?? "",
        subType: action.subType ?? ""
      });
    default:
      return state;
  }
}
